import azState from "../../../../assets/arizona_map.png";
import treemap from "../../../../assets/treemap.png";
import barLine from "../../../../assets/stacked_bar_chart.png";

export const charts = [
  {
    id: "title_map",
    icon: azState,
    name: "Cities",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    // title: "Cities: Salt River Valley Water Users Association",
    title: "Cities",
    subtitle: "",
    floating_title: true,
    water_user_disabled: false,
    scenario_disabled: true,
    show_stats: true,
    // metrics: [
    //   { label: "City Name: Use of Colorado River Water", value: "xx.xx%" },
    //   { label: "Customer taps", value: "xx.xx%" },
    //   { label: "Recharged water use", value: "xx.xx%" },
    //   { label: "Turf facilities", value: "xx.xx%" },
    // ],
  },
  {
    id: "community_water_use",
    icon: treemap,
    name: "City Colorado River Use",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "City Colorado River Use",
    subtitle: "",
    floating_title: false,
    scenario_disabled: true,
    water_user_disabled: true,
    show_stats: false,
    // metrics: [
    //   { label: "City Name: Use of Colorado River Water", value: "xx.xx%" },
    //   { label: "Direct water use", value: "xx.xx%" },
    //   { label: "Recharged water use", value: "xx.xx%" },
    //   { label: "Turf facilities", value: "xx.xx%" },
    // ],
  },
  {
    id: "water_company_use",
    icon: barLine,
    name: "Cities: Shortage Impacts",
    desc: "Explanation about what this means and what the narrative measures on the base level.",
    title: "Cities: Shortage Impacts (acre-feet)",
    subtitle: "",
    floating_title: false,
    water_user_disabled: false,
    scenario_disabled: false,
    show_stats: true,
    // metrics: [
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    //   { label: "Metric Name", value: "Xx,xxx ac-ft" },
    // ],
  },
];

export const about = [
  {
    title: "Summary",
    desc: "Colorado River water is delivered into Maricopa, Pinal, and Pima counties via the Central Arizona Project (CAP) canal.  This map shows the cities and private water companies in Central Arizona that have access to Colorado River water. For the most part, these municipal water providers have lower priority rights to Colorado River water than most mainstem users in Western Arizona and experience cuts to their supplies before mainstem users when there isn’t enough water to go around. The stats indicate the amount of Colorado River water delivered by each city to customer taps, to turf (schools, parks, golf courses, cemeteries, HOAs, etc) and for aquifer recharge.",
  },
  {
    title: "Summary",
    desc: "Cities have access to various water supplies, typically including Colorado River water, other surface water such as Salt and Verde, groundwater, and reclaimed water.  With this chart and hover tool, a user can see the purposes for which cities are currently making use of these different water supplies. (Based on 2020 data).",
  },
  {
    title: "Summary",
    desc: "Using the slider at the top, a user can see the quantity of Colorado River water available in Central Arizona at each shortage tier and under more severe scenarios. On the chart, the amount of Colorado River water available to each city under different shortage scenarios is compared with the purposes for which the city made use of its Colorado River water in 2020.",
  },
];

export const cities = [
  { label: "Subject", value: 0 },
  { label: "Subject", value: 1 },
  { label: "Subject", value: 2 },
  { label: "Subject", value: 3 },
];
